var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIconOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F78670"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2125 6.00146H12.7914C12.9318 6.00146 13.002 6.04591 13.002 6.1348V17.8681C13.002 17.957 12.9318 18.0015 12.7914 18.0015H11.2125C11.0721 18.0015 11.002 17.957 11.002 17.8681V6.1348C11.002 6.04591 11.0721 6.00146 11.2125 6.00146Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14149 11.0015H17.8624C17.9554 11.0015 18.002 11.0716 18.002 11.212V12.7909C18.002 12.9313 17.9554 13.0015 17.8624 13.0015H6.14149C6.04846 13.0015 6.00195 12.9313 6.00195 12.7909V11.212C6.00195 11.0716 6.04846 11.0015 6.14149 11.0015Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconOrange);
export default __webpack_public_path__ + "static/media/plusIconOrange.fd8dac1b92e6b38a5bf1427cb48cfbb4.svg";
export { ForwardRef as ReactComponent };